export const MathUtil: any = {};

export function slerp1d(a: any, b: any) {
  const twoPi = Math.PI * 2;
  const targetDir = ((a % twoPi) + twoPi) % twoPi;
  const thisDir = ((b % twoPi) + twoPi) % twoPi;
  let deltaDir = targetDir - thisDir;
  const absDeltaDir = Math.abs(deltaDir);
  let signDeltaDir = absDeltaDir === deltaDir ? +1 : -1;
  if (absDeltaDir > Math.PI) {
    deltaDir = signDeltaDir * (2 * Math.PI - absDeltaDir) * -1;
  }
  return deltaDir;
}
MathUtil.slerp1d = slerp1d;

